import classes from "./FieldDataC.module.css";
import {  Route, Routes } from "react-router-dom";

import Dashboard from "../Dashboard/Dashboard";

import WeightBridgeDetail from "../WeightBridgeInward/WeightBridgeDetail";
import WeightBridgeNew from "../WeightBridgeInward/WeightBridgeNew";
import WeightBridgeView from "../WeightBridgeInward/WeightBridgeView";
import InwardGatePass from "../InwardGate/Issuereturnnew";

import InwardDetail from "../inwardgatepass/InwardView";
import OutwardDetail from "../IssueReturn/Issuedetail";
import GatePassOutwardNew from "../IssueReturn/Issuereturnnew";
import GateRegister from "../Register/BreakdownFeeding";
import PendingRegister from "../Register/FurnaceProduction";
import OutRester from "../Register/RollingProduction";

const FieldDataS = (fieldProps) => {
 
  return (
    <div className={classes["Fields"]}>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        
        <Route
          path="/transaction/weighbridge"
          element={<WeightBridgeDetail />}
        />

        <Route
          path="/transaction/weighbridge-create"
          element={<WeightBridgeNew />}
        />

        <Route
          path="/transaction/weighbridge-form-view/:id"
          element={<WeightBridgeView />}
        />

        <Route path="transaction/inwardgatepass" element={<InwardGatePass />} />
        <Route
          path="transaction/outwardgatepass"
          element={<GatePassOutwardNew />}
        />

        <Route path="transaction/inward-view" element={<InwardDetail />} />
        <Route path="transaction/outward-view" element={<OutwardDetail />} />
        <Route path="/inward-gatePass-register" element={<GateRegister />} />
        <Route
          path="/pending-inward-gate-pass-register"
          element={<PendingRegister />}
        />``````````

        <Route path="/outward-gatepass-register" element={<OutRester />} />
      </Routes>
    </div>
  );
};

export default FieldDataS;
